(() => {
  if (customElements.get('jupityr-supply-selector')) return;
  class SupplySelector extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.form = document.getElementById(this.dataset.form);
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.subscribe = this.querySelector('[data-supply-subscribe]');
      this.quantity = this.querySelector('[data-supply-quantity]');
      this.plan = this.form?.querySelector('[data-supply-selling-plan]');
      this.dock = document.querySelector('[data-supply-dock="' + CSS.escape(this.dataset.section) + '"]');
      if (!this.form || !this.plan || this.radios.some(r => !r.dataset.plan || Number(r.dataset.sub) <= 0)) return;
      this.addEventListener('change', () => this.update(), { signal });
      this.dock?.addEventListener('click', event => {
        const choice = event.target.closest('[data-supply-dock-choice]');
        if (choice) {
          this.radios.find(r => r.value === choice.dataset.supplyDockChoice).checked = true;
          this.update();
          this.closeDock();
        }
        if (event.target.closest('[data-supply-close]')) this.closeDock();
      }, { signal });
      this.dock?.querySelector('[data-supply-dock-subscribe]')?.addEventListener('change', event => {
        this.subscribe.checked = event.target.checked;
        this.update();
      }, { signal });
      document.addEventListener('click', event => {
        if (this.dock && !this.dock.contains(event.target)) this.closeDock(false);
      }, { signal });
      this.dock?.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.closeDock(); }
      }, { signal });
      // Shrine already handles AJAX, upsells, cart rendering and selling plans.
      // Keep its native form fields synchronized, including an upsell's items[] payload.
      this.form.addEventListener('formdata', event => {
        const data = event.formData;
        for (const [key, value] of [...data.entries()]) {
          if (/^items\[\d+\]\[id\]$/.test(key) && value === this.form.querySelector('[name="id"]').value) {
            const prefix = key.replace(/\[id\]$/, '');
            data.set(prefix + '[quantity]', this.quantity.value);
            if (this.plan.value) data.set(prefix + '[selling_plan]', this.plan.value);
            else data.delete(prefix + '[selling_plan]');
          }
        }
      }, { signal });
      this.update(false);
      // The server-rendered options reserve their space from first paint.
      // Unlock them and purchasing only after native form values are synchronized.
      const ui = this.querySelector('.jupityr-supply-ui');
      ui.hidden = false;
      ui.removeAttribute('inert');
      const pendingButton = this.form.querySelector('[data-supply-pending]');
      if (pendingButton) {
        pendingButton.disabled = false;
        pendingButton.removeAttribute('aria-disabled');
        pendingButton.removeAttribute('aria-busy');
        pendingButton.removeAttribute('data-supply-pending');
      }
      if (this.dock) this.dock.hidden = false;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    closeDock(focus = true) {
      const details = this.dock?.querySelector('details');
      if (!details?.open) return;
      details.open = false;
      if (focus) details.querySelector('summary').focus();
    }
    update(announce = true) {
      const selected = this.radios.find(r => r.checked);
      const recurring = this.subscribe.checked;
      const labelKey = recurring ? 'subLabel' : 'onceLabel';
      this.quantity.value = selected.value;
      this.plan.value = recurring ? selected.dataset.plan : '';
      this.plan.dispatchEvent(new Event('change', { bubbles: true }));
      const months = Number(selected.value);
      const supply = months + (months === 1 ? ' Month Supply' : ' Months Supply');
      const frequency = months === 1 ? 'every month' : 'every ' + months + ' months';
      const delivery = recurring ? 'Delivery ' + frequency + ' | Skip or cancel anytime' : months + (months === 1 ? ' product delivered once' : ' products delivered once');
      this.querySelector('[data-supply-delivery]').textContent = delivery;
      this.radios.forEach(r => {
        r.closest('label').querySelector('[data-supply-price]').textContent = r.dataset[labelKey];
        r.closest('label').querySelector('[data-supply-compare]').hidden = !recurring && r.value === '1';
        const price = this.dock?.querySelector('[data-supply-dock-price="' + r.value + '"]');
        if (price) price.textContent = r.dataset[labelKey];
        this.dock?.querySelector('[data-supply-dock-choice="' + r.value + '"]')?.setAttribute('aria-pressed', String(r.checked));
      });
      if (this.dock) {
        this.dock.querySelector('summary .jupityr-supply-image').dataset.count = selected.value;
        this.dock.querySelector('[data-supply-dock-title]').textContent = supply;
        this.dock.querySelector('[data-supply-dock-mode]').textContent = recurring ? 'Subscribe & Save 25%' : 'One-time purchase';
        this.dock.querySelector('[data-supply-dock-subscribe]').checked = recurring;
        this.dock.querySelector('[data-supply-dock-delivery]').textContent = delivery;
      }
      for (const id of ['main-atc-price-', 'sticky-atc-price-']) {
        const target = document.getElementById(id + this.dataset.section);
        if (target) target.textContent = selected.dataset[labelKey];
      }
      if (announce) this.querySelector('[data-supply-status]').textContent = supply + ', ' + selected.dataset[labelKey] + ', ' + delivery;
    }
  }
  customElements.define('jupityr-supply-selector', SupplySelector);
})();
